import React, { FC } from 'react';

import { fontFamilies } from 'components/UI/Font';

export const DescriptionShippingAndReturns: FC<{
  country: string;
  isCountryDDP: boolean;
}> = ({ country, isCountryDDP }) => {
  return (
    <>
      <div>
        <span className="bold">At a glance:</span>
        <ul>
          <li>
            <span className="bold">Free express shipping worldwide (2-4 business days)</span>
          </li>
          <li>DHL requires a signature for all packages.</li>
          <li>You can request a return within 14 days of receiving your order.</li>
          <li>We do not accept returns for underwear, swimwear, fur coats, down jackets, or jewelry.</li>
        </ul>
      </div>
      <p className="duties-info">
        You are shipping to <span className="bold">{country}</span>.
        {isCountryDDP
          ? ' Duties will be calculated at checkout; no additional duties are due upon delivery.'
          : ' Duties are NOT included and are due upon delivery.'}
      </p>

      <style jsx>{`
        .bold {
          font-family: ${fontFamilies.bold};
          font-weight: 400;
        }

        ul {
          list-style-type: disc;
          margin-top: 10px;
        }

        li {
          line-height: 20px;
        }
      `}</style>
    </>
  );
};
